export default __webpack_public_path__ + "static/media/Raider's Jerkin of the Ritual Flame.282d9d39.jpg";